/**
 * Detecção de modalidade de entrada para o anel de foco (US 8864 / CR1).
 *
 * Botões e links resolvem com `:focus-visible` puro — o navegador já aplica a
 * heurística certa neles. Campo de digitação não: em <input> de texto,
 * <textarea> e contenteditable o navegador SEMPRE casa `:focus-visible`,
 * inclusive quando o foco vem do clique, porque o usuário está prestes a
 * digitar. Não há como separar Tab de clique nesses elementos em CSS.
 *
 * Solução: marcar em <html> de onde veio a última interação e deixar o CSS
 * (assets/css/acessibilidade.css) escopar o anel dos campos em
 * `[data-entrada="teclado"]`.
 */
const TECLAS_DE_NAVEGACAO = new Set([
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Home",
  "End",
  "PageUp",
  "PageDown",
]);

function marcarTeclado(evento) {
  // Atalho de sistema (Cmd+Tab, Alt+Tab) não é navegação dentro da página.
  if (evento.metaKey || evento.altKey || evento.ctrlKey) return;
  if (!TECLAS_DE_NAVEGACAO.has(evento.key)) return;
  document.documentElement.dataset.entrada = "teclado";
}

function marcarPonteiro() {
  document.documentElement.dataset.entrada = "ponteiro";
}

// Fase de captura: roda antes de qualquer handler da aplicação, então o
// atributo já está correto quando o foco se move e o CSS é avaliado.
document.addEventListener("keydown", marcarTeclado, true);
document.addEventListener("pointerdown", marcarPonteiro, true);
